/**
 * Fiji dollar.
 */
export var FJD = {
  code: 'FJD',
  base: 10,
  exponent: 2
};